const locale = {
  TITLE: 'Create Patient page',
  WARNING_MESSAGE:
    'Please create a Patient Group before opening the Patient page. You will now be redirected to the Patient Group page in {{ time }} seconds',
  WARNING_TITLE: 'Patient Group',
};

export default locale;
